import { useEffect, useState } from "react";
import {
  AdesaoCard,
  HeaderCollum,
  HeaderRow,
  LeftContent,
  RightContent,
  SesiImage,
  ValidationStyle,
  ValidationTitle,
  WrapAdesao,
  WrapContent,
  SelectionIndicator,
  WrapTitleAndButtons,
  DenyButton,
  AcceptButton,
  WrapButtons,
  BackButton,
  SelectAllButton,
  ModalOverlay,
  ModalContent,
  ModalInput,
  ModalButtons,
  ModalTextarea,
  LoadingOverlay,
  Spinner,
} from "../../styles/Validation";
import SESI from "../../assets/img/sesi.png";
import { getAdesaoList } from "../../data/services/enterprise_service";
import { acceptAdesao } from "../../data/provider/enterprise/api_enterprise";
import { useNavigate } from "react-router-dom";
import { HOME_LOGGED } from "../../core/app-urls";
import { toast, ToastContainer } from "react-toastify";
import AdesaoValidationModel from "../../data/models/adesaoValidation";

export default function Validation() {
  const [selectedCards, setSelectedCards] = useState<number[]>([]);
  const [adesoes, setAdesoes] = useState<AdesaoValidationModel[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [reason, setReason] = useState<string>("");
  const [showModal, setShowModal] = useState<boolean>(false);
  const [processing, setProcessing] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    fetchAdesoes();
  }, []);

  const fetchAdesoes = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await getAdesaoList(localStorage.getItem("id")!);
      if (response.data) {
        setAdesoes(response.data);
      } else {
        setError("Nenhum dado encontrado.");
      }
    } catch (err) {
      setError("Erro ao buscar adesões.");
    } finally {
      setLoading(false);
    }
  };

  const handleInput = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    const textarea = event.target;
    textarea.style.height = "auto";
    textarea.style.height = `${textarea.scrollHeight}px`;
  };

  const toggleSelection = (id: number) => {
    setSelectedCards((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id]
    );
  };

  const handleAcceptOrDeny = async (accept: string) => {
    if (selectedCards.length === 0) {
      toast.warning("Selecione pelo menos uma adesão.");
      return;
    }

    if (accept === "N") {
      setShowModal(true);
      return;
    }

    try {
      setProcessing(true);
      await acceptAdesao(selectedCards, accept, reason);

      toast.success("Adesões aprovadas com sucesso!");

      setSelectedCards([]);
      fetchAdesoes();
    } catch (error) {
      toast.error("Erro ao processar adesões.");
    } finally {
      setProcessing(false);
    }
  };

  const confirmRejection = async () => {
    try {
      setProcessing(true);
      await acceptAdesao(selectedCards, "N", reason);

      toast.success("Adesões reprovadas com sucesso!");

      setSelectedCards([]);
      fetchAdesoes();
      setShowModal(false);
    } catch (error) {
      toast.error("Erro ao processar adesões.");
    } finally {
      setProcessing(false);
    }
  };

  const toggleSelectAll = () => {
    if (selectedCards.length === adesoes.length) {
      setSelectedCards([]);
    } else {
      setSelectedCards(adesoes.map((adesao) => adesao.id!));
    }
  };

  const handleLogout = () => {
    navigate(HOME_LOGGED);
  };

  return (
    <ValidationStyle>
      <ToastContainer />
      <WrapContent>
        <BackButton onClick={handleLogout}>VOLTAR</BackButton>
        <HeaderRow>
          <SesiImage src={SESI} />
          <HeaderCollum>
            <h1>Olá, {localStorage.getItem("name")}</h1>
            <h2>Seja bem-vindo(a) ao PORTAL DO CLIENTE</h2>
          </HeaderCollum>
        </HeaderRow>
        <WrapTitleAndButtons>
          <ValidationTitle>Validação de Adesões</ValidationTitle>
          <SelectAllButton onClick={toggleSelectAll}>
            {selectedCards.length === adesoes.length
              ? "Desmarcar todos"
              : "Selecionar todos"}
          </SelectAllButton>
          <WrapButtons>
            <DenyButton
              disabled={processing}
              onClick={() => handleAcceptOrDeny("N")}
            >
              {processing ? "Processando..." : "Reprovar"}
            </DenyButton>
            <AcceptButton
              disabled={processing}
              onClick={() => handleAcceptOrDeny("S")}
            >
              {processing ? "Processando..." : "Aprovar"}
            </AcceptButton>
          </WrapButtons>
        </WrapTitleAndButtons>
        {loading ? (
          <p>Carregando adesões...</p>
        ) : error ? (
          <p>{error}</p>
        ) : (
          <WrapAdesao>
            {adesoes.map((adesao) => (
              <AdesaoCard
                key={adesao.id}
                onClick={() => toggleSelection(adesao.id!)}
              >
                <LeftContent>
                  <h2>{adesao.nome}</h2>
                  <h2>
                    Plano: {adesao.categoria}
                  </h2>
                  <h2>Valor: R$ {adesao.valor}</h2>
                </LeftContent>
                <RightContent>
                  <SelectionIndicator
                    selected={selectedCards.includes(adesao.id!)}
                  />
                </RightContent>
              </AdesaoCard>
            ))}
          </WrapAdesao>
        )}
      </WrapContent>
      {processing && (
        <LoadingOverlay>
          <Spinner />
          <p style={{ color: "white", marginTop: "10px" }}>Processando...</p>
        </LoadingOverlay>
      )}

      {showModal && (
        <ModalOverlay>
          <ModalContent>
            <h2>Motivo da reprovação</h2>
            <ModalTextarea
              placeholder="Digite o motivo"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              onInput={handleInput}
            />
            <ModalButtons>
              <button onClick={() => setShowModal(false)}>Cancelar</button>
              <button onClick={confirmRejection}>Confirmar</button>
            </ModalButtons>
          </ModalContent>
        </ModalOverlay>
      )}
    </ValidationStyle>
  );
}
